import React from "react";
import { HiDocumentDuplicate } from "react-icons/hi";

const DuplicateButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-6 h-6 flex justify-center items-center bg-red-100 text-amber-600 rounded-full scale-100 hover:scale-110 duration-300"
    >
      <HiDocumentDuplicate className="text-lg" />
    </button>
  );
};

export default DuplicateButton;
